module.exports = __webpack_public_path__ + "static/img/smartInterc.f68326f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smartInterc.png
// module id = Su/2
// module chunks = 1